import instObj from '@/backend/axios-instances'

const resource = "/ticketing"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(`${resource}/tickets`, { params: parameters });
  },
  post(data) {
    return instance.post(`${resource}/tickets`, data);
  }
}
